import React, { useState, useEffect } from 'react';
import { MessageCircle, Star } from 'lucide-react';
import { getReviews } from '../services/reviewService';
import ReviewForm from './ReviewForm';
import ReviewList from './ReviewList';

interface TaxiStandReviewsProps {
  taxiStandId: string;
  totalReviews: number;
  rating: number;
}

export default function TaxiStandReviews({ taxiStandId, totalReviews, rating }: TaxiStandReviewsProps) {
  const [reviews, setReviews] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showReviewForm, setShowReviewForm] = useState(false);

  useEffect(() => {
    if (taxiStandId) {
      loadReviews();
    }
  }, [taxiStandId]);

  const loadReviews = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getReviews(taxiStandId);
      setReviews(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Yorumlar yüklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleReviewSuccess = () => {
    setShowReviewForm(false);
    loadReviews();
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="p-2.5 bg-yellow-400/10 rounded-xl">
            <MessageCircle className="w-5 h-5 text-yellow-400" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white">
              Müşteri Yorumları
            </h2>
            <div className="flex items-center gap-2 mt-1">
              <div className="flex items-center gap-1">
                <Star className="w-4 h-4 text-yellow-400 fill-current" />
                <span className="font-medium text-white">{rating.toFixed(1)}</span>
              </div>
              <span className="text-sm text-gray-400">
                ({totalReviews} yorum)
              </span>
            </div>
          </div>
        </div>

        <button
          onClick={() => setShowReviewForm(true)}
          className="px-4 py-2 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-medium rounded-lg transition-colors"
        >
          Yorum Yap
        </button>
      </div>

      {/* Review Form */}
      {showReviewForm && (
        <div className="bg-gray-800 rounded-xl p-6 border border-white/5">
          <ReviewForm
            taxiStandId={taxiStandId}
            onSuccess={handleReviewSuccess}
            onCancel={() => setShowReviewForm(false)}
          />
        </div>
      )}

      {/* Reviews */}
      <ReviewList
        reviews={reviews}
        isLoading={loading}
        error={error || undefined}
      />
    </div>
  );
}